module.exports = __webpack_public_path__ + "static/media/blog_52.73f091c0.webp";